module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/c2UvmZ/tc-custom/9781488035036.jpg?1703048324615",
      "alt": "This image is the cover for the book Missing Daughter"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Missing Daughter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("When a twelve-year-old girl goes missing, a suburban family’s perfect life reveals its dark secrets in this tense psychological thriller.")]), _c('br'), _c('br'), _vm._v("Life can change in an instant. For Ryan and Karen Lane, it happens on the morning they discover their twelve-year-old daughter’s window open, their beloved Maddie missing from her bed. Police investigate. Suspicions swirl. The Lane family is thrown into turmoil. Then detectives turn their sights on them."), _c('br'), _c('br'), _vm._v("No one is ruled out. Not Karen, with her tragic past, who argued with her daughter. Not Ryan, with his violent streak. Not Maddie’s thirteen-year-old brother, Tyler, who heard voices in her room the night she vanished."), _c('br'), _c('br'), _vm._v("As time goes by and no answers emerge, the Lanes fear that Maddie is gone forever. But when a stunning revelation shocks everyone, the family plunges deep into a world of buried secrets whose revelations threaten the very foundation of their lives.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rick Mofina\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Rick Mofina is a former crime reporter and the award-winning author of several acclaimed thrillers. He's interviewed murderers face-to-face on death row; patrolled with the LAPD and the RCMP. His true crime articles have appeared in The New York Times, Marie Claire, Reader’s Digest and Penthouse. He's reported from the U.S., Canada, the Caribbean, Africa, Qatar and Kuwait's border with Iraq. For more information please visit www.rickmofina.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0